// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"31cce9cc","310":"a7fc1dbb","453":"2e4f23d3"}[chunkId] + ".chunk.js";
};